import { createIcon, Svg } from "@gluestack-ui/icon";
import { Path } from "react-native-svg";

const UploadCloudIcon = createIcon({
  Root: Svg,
  viewBox: "0 0 20 18",
  path: (
    <Path
      d="M6.66675 12.3333L10.0001 9M10.0001 9L13.3334 12.3333M10.0001 9V16.5M16.6667 12.9524C17.6847 12.1117 18.3334 10.8399 18.3334 9.41667C18.3334 6.88536 16.2814 4.83333 13.7501 4.83333C13.568 4.83333 13.3976 4.73833 13.3052 4.58145C12.2185 2.73736 10.2121 1.5 7.91675 1.5C4.46497 1.5 1.66675 4.29822 1.66675 7.75C1.66675 9.47175 2.36295 11.0309 3.48921 12.1613"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
});

const UploadCloudTwoIcon = createIcon({
  Root: Svg,
  viewBox: "0 0 58 42",
  path: (
    <Path
      d="M14.7904 41.6693C10.8637 41.6693 7.51398 40.3173 4.7412 37.6134C1.96842 34.8923 0.582031 31.577 0.582031 27.6676C0.582031 24.3093 1.58953 21.3126 3.60453 18.6776C5.63675 16.0426 8.28898 14.3634 11.5612 13.6401C12.6462 9.67899 14.799 6.47566 18.0195 4.0301C21.2573 1.56733 24.917 0.335938 28.9987 0.335938C34.0448 0.335938 38.3159 2.0926 41.812 5.60594C45.3254 9.10205 47.082 13.3732 47.082 18.4193C50.0615 18.7637 52.5243 20.0554 54.4704 22.2943C56.4337 24.4987 57.4154 27.082 57.4154 30.0443C57.4154 33.282 56.2873 36.029 54.0312 38.2851C51.7751 40.5412 49.0281 41.6693 45.7904 41.6693H31.582C30.1698 41.6693 28.9556 41.1612 27.9395 40.1451C26.9234 39.1462 26.4154 37.932 26.4154 36.5026V23.1984L22.282 27.2026L18.6654 23.5859L28.9987 13.2526L39.332 23.5859L35.7154 27.2026L31.582 23.1984V36.5026H45.7904C47.5987 36.5026 49.1229 35.874 50.3629 34.6168C51.6201 33.3768 52.2487 31.8526 52.2487 30.0443C52.2487 28.2359 51.6201 26.7118 50.3629 25.4718C49.1229 24.2145 47.5987 23.5859 45.7904 23.5859H41.9154V18.4193C41.9154 14.8543 40.6581 11.8059 38.1437 9.27427C35.6293 6.75983 32.5809 5.5026 28.9987 5.5026C25.4337 5.5026 22.3854 6.75983 19.8537 9.27427C17.3393 11.8059 16.082 14.8543 16.082 18.4193H14.7904C12.2931 18.4193 10.1662 19.3062 8.40953 21.0801C6.63564 22.8368 5.7487 24.9637 5.7487 27.4609C5.7487 29.9582 6.63564 32.1109 8.40953 33.9193C10.1662 35.6415 12.2931 36.5026 14.7904 36.5026H21.2487V41.6693"
      stroke="none"
    />
  ),
});

export { UploadCloudIcon, UploadCloudTwoIcon };
